<template>
  <div class="content">
    <h3 class="subtitle has-text-weight-light has-text-centered">
      &mdash;
      {{ title }}
      &mdash;
    </h3>
    <p v-html="text" />
    <br />
    <b v-html="conclusion"/>
  </div>
</template>

<script>
export default {
    name: 'ProductParagraph',
    props: {
        title: String,
        text: String,
        conclusion: String,
    }
}
</script>

<style scoped>
.content p {
    width: 90%;
    line-break: break-all;
}
</style>